<template>
    <form-group :validator="v" :label="label" :label-for="id" :description="tip" :messages="messages">
        <template slot-scope="{ attrs, listeners }">
          <v-select :id="id"
                :value="value"
                :state="v.$dirty ? !v.$error : null"
                v-bind="attrs"
                v-on="listeners"
                :data-test="slug"
                :required="!v.required"
                @input="onSelected"
                :options="options"
                :getOptionLabel="option => option.label"
                :filterBy="myFilterBy"
                :disabled="disabled"
                placeholder="-- Please select an option --"
          >
            <template slot="no-options">
                Type to search options.
            </template>
              <template #option="{label}">
                  <div class="d-center">
                      {{label}}
                  </div>
              </template>
            <template #search="{attributes, events}">
                    <input
                    class="vs__search"
                    :required="!value"
                    v-bind="attributes"
                    v-on="events"
                    />
            </template>
        </v-select>

        </template>
      </form-group>
</template>

<script>
import _ from "lodash"

export default {
    props: {
        value: [Object, String],
        label: [String],
        tip: [String],
        slug: [String],
        options: [Array],
        v: [Object],
        required: [Boolean],
        disabled: [Boolean],
        setId: [String],
        messages: [Object],
    },
    
    computed: {
        id() {
            if (this.setId === null) {
                return _.uniqueId('searchableSelector')
            } else {
                return this.setId
            }
        }
    },

    methods: {
        onSelected(item) {
            this.$emit('input', item)
        },
        myFilterBy(option, label, search) {
          if(search.length < 2) {
            return true
          }
          return (label || '').toLowerCase().indexOf(search.toLowerCase()) > -1
        },

  },
}
</script>

<style>
.form-group > label {
    font-size: inherit;
    font-weight: 750;
}
legend {
    font-size: inherit;
    font-weight: 700;
}
</style>